import React from "react";
import SmartPromptEditor from "../../components/SmartPromptEditor";
import { templateSmartPrompt } from "../../helpers/smartPrompt";

export default function AgentInstructions({ form, setField, origin, errors, companyName, companyValues, disabled = false }) {
  return <SmartPromptEditor value={form.promptDocument} onChange={value => setField("promptDocument", value)}
    disabled={disabled} companyName={companyName} companyValues={companyValues} templateDocument={origin?.instructions ? templateSmartPrompt(origin) : null}
    error={errors.find(item => item.field === "promptDocument")?.message} />;
}
